import { create } from 'zustand';
import type { GenerationBonusPackRef } from '../types/domain';

export const MAX_SELECTED_VOICE_PACKS = 2;

interface BonusPackSelectionState {
  voicePacks: GenerationBonusPackRef[];
  samplePack: GenerationBonusPackRef | null;
  addVoicePack: (pack: GenerationBonusPackRef) => 'added' | 'duplicate' | 'limit';
  selectSamplePack: (pack: GenerationBonusPackRef) => void;
  removePack: (kind: GenerationBonusPackRef['kind'], bonusId: string, entryIndex: number) => void;
  clear: () => void;
}

export const useBonusPackSelectionStore = create<BonusPackSelectionState>((set, get) => ({
  voicePacks: [],
  samplePack: null,

  addVoicePack(pack) {
    const current = get().voicePacks;
    if (
      current.some(
        (entry) => entry.bonusId === pack.bonusId && entry.entryIndex === pack.entryIndex
      )
    ) {
      return 'duplicate';
    }
    if (current.length >= MAX_SELECTED_VOICE_PACKS) return 'limit';
    set({ voicePacks: [...current, { ...pack, kind: 'voice' }] });
    return 'added';
  },

  selectSamplePack(pack) {
    set({ samplePack: { ...pack, kind: 'sample' } });
  },

  removePack(kind, bonusId, entryIndex) {
    if (kind === 'sample') {
      const current = get().samplePack;
      if (current?.bonusId === bonusId && current.entryIndex === entryIndex)
        set({ samplePack: null });
      return;
    }
    set({
      voicePacks: get().voicePacks.filter(
        (entry) => entry.bonusId !== bonusId || entry.entryIndex !== entryIndex
      ),
    });
  },

  clear() {
    set({ voicePacks: [], samplePack: null });
  },
}));

export function selectedGenerationBonusPacks(): GenerationBonusPackRef[] {
  const { voicePacks, samplePack } = useBonusPackSelectionStore.getState();
  return [...voicePacks, ...(samplePack ? [samplePack] : [])];
}
